import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import styled, {css, keyframes } from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const styles=makeStyles((theme)=>(
  {
    links: {
      textDecoration: 'none',
      color: 'white',
      '&:hover': {
        color: 'white',
      },
    }
    
  }
))

const marquee = keyframes`
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const StyledDiv = styled.div`
  padding: 20px auto;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  background: #124076; // dark blue
`;

const Text = styled.span`
  display: inline-block;
  font-size: 25px;
  animation: ${props => props.isPaused ? 'none' : css`${marquee} 35s infinite linear`};
  font-family: "Inter", sans-serif;
  color: #fff;
  font-family: merriweather;
  transition: animation 0.5s ease; // Smooth transition for animation change
`;

const LineText=styled.link`
  text-decoration:none
`

const Marquee = ({ currentContent }) => {
  const marqueeRef = useRef(null);

  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop(); 
    }
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start(); 
    }
  };

  return (
    <marquee 
      ref={marqueeRef}
      onMouseOver={handleMouseOver} 
      onMouseOut={handleMouseOut} 
      style={{ background: '#124076', color: '#fff', fontSize: '25px', padding: '20px auto' }}
    >
      {currentContent.map((story, key) => {
        if (key >= 3) {
          return (
            <Link to={`/story/${story.slug}`} style={{ textDecoration: 'none', color: 'white' }} key={key}>
              <span>{story.title} &ensp;&ensp;</span>
            </Link>
          );
        }
        return null; // Return null for keys less than 3
      })}
    </marquee>
  );
};

export default Marquee;
